const CheckIcon = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.86792 4.62049C9.04381 4.44491 9.04406 4.15998 8.86848 3.98409C8.6929 3.8082 8.40797 3.80795 8.23208 3.98353L5.14828 7.06189L3.7682 5.68181C3.59246 5.50607 3.30754 5.50607 3.1318 5.68181C2.95607 5.85755 2.95607 6.14247 3.1318 6.31821L4.8298 8.01621C5.00543 8.19183 5.29014 8.19196 5.46592 8.01649L8.86792 4.62049Z" fill="#DDFDB3"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M6 12C9.3 12 12 9.3 12 6C12 2.7 9.3 0 6 0C2.7 0 0 2.7 0 6C0 9.3 2.7 12 6 12ZM11.1 6C11.1 8.80294 8.80294 11.1 6 11.1C3.19706 11.1 0.9 8.80294 0.9 6C0.9 3.19706 3.19706 0.9 6 0.9C8.80294 0.9 11.1 3.19706 11.1 6Z" fill="#DDFDB3"/>
        </svg>
    )
}

export default CheckIcon;